import type { UpsellCategoryKey, UpsellMetadata } from "@/shared/types/common";

// Fallback metadata used by getUpsellMetadata when the backend hasn't yet
// shipped copy for a given category in plan.upsell_promotion. Backend values
// always take precedence; entries here only render when missing server-side.
export const UPSELL_FALLBACK_METADATA: Partial<Record<UpsellCategoryKey, UpsellMetadata>> = {
  classifieds: {
    tooltip: "Offrez à vos salariés un espace pour publier et consulter des petites annonces entre collègues.",
    title: "Offrez à vos salariés un espace de petites annonces entre collègues.",
    description: "Centralisez les échanges du quotidien — ventes, dons, services, covoiturage — et renforcez les liens entre salariés.",
    features: [
      { icon: "Tag", text: "Publication d'annonces en quelques clics" },
      { icon: "Search", text: "Recherche par catégorie et mots-clés" },
      { icon: "MessageSquare", text: "Mise en relation directe entre salariés" },
      { icon: "Users", text: "Modération par les administrateurs du CSE" },
      { icon: "Handshake", text: "Échanges de biens, services et bons plans" },
      { icon: "Newspaper", text: "Fil d'annonces dédié à votre entreprise" },
    ],
  },
};
